import { render } from "./Third.vue?vue&type=template&id=637b1a37&scoped=true"
import script from "./Third.vue?vue&type=script&lang=js"
export * from "./Third.vue?vue&type=script&lang=js"

import "./Third.vue?vue&type=style&index=0&id=637b1a37&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637b1a37"]])

export default __exports__